import { API } from '../../Config'
import { API_GET } from '../../Config'

export const GetHomePagelinks = () => {
    
  return (
    API_GET(API.HomepageLinks)
  )
}

